<div [ngClass]="setClass()" style="display: flex; flex-direction: column;  flex-wrap: wrap;" (click)="openReportDetails()">
<!--     <div class="avatar" margin="8px">
        <app-avatar-circle [name]="this.report()?.CreatedByFirstName + ' ' + this.report()?.CreatedByLastName" [backgroundColor]="this.report()?.ScoutBgColor ?? '#1976d2'"></app-avatar-circle>   
    </div> -->
<div class="report-title">
             @if (this.report()?.PlayerCurrentTeamIcon!=null) {
                <img style="max-height: 40px; max-width: 40px; margin-right: 5px;" [src]="('assets/img/' + this.report()?.PlayerCurrentTeamIcon).replace('//','/').toLowerCase()"    >
            }
            <div style="display: flex; flex-direction: column;width: 100%;">
                <div style="display: flex; flex-direction: row;  ">
                    <a  [routerLink]="['/player/details', this.report()?.PlayerId]" class="report-title linktext">
                    {{ this.report()?.PlayerLastName}}, {{ this.report()?.PlayerFirstName}} 
                    </a>
                    <div class="spacer"></div>
                    <div class="timeago">{{getTimeAgo()}}</div>
                </div>
                <div>
                    <div style="font-size: 10px; font-weight: normal; ">
            @if (this.report()?.PositionId===1) {
                <span style="font-weight: normal;">
                Goaltender -
                </span>
            }
            @if (this.report()?.PositionId===2 || this.report()?.PositionId===3 ) {
                <span >
                Defender -
                </span>
            }
            @if (this.report()?.PositionId ?? 0>3) {
                <span>
                Forward -
                </span>
            }
            <span >

                {{ this.report()?.DateOfBirth | date:'yyyy-MM-dd'}} ({{this.report()?.PlayerAgeYear + ' Years ' + this.report()?.PlayerAgeMonth + ' Months'}})

            </span>
            <br>
                @if (this.report()?.ReportDivision != null && this.report()?.ReportTeamName != null) {
                <span>
                    {{this.report()?.ReportDivision ?? "" + "/" + this.report()?.ReportTeamName}}<br/>
                </span>
                }
                @if (this.report()?.ReportDivision === null || this.report()?.ReportTeamName === null) {
                <span>
                    {{this.report()?.PlayerCurrentDivision ?? "" + "/" + this.report()?.PlayerCurrentTeam}}<br/>
                </span>
                }

                    </div>
                    
                </div>                   
            </div>                        
        </div>
    <div class="report-tight-content">        
        
        <!-- <mat-divider/> -->
        <div class="ReportText">
            Comment<br/>    
            {{ this.report()?.Text }} </div>
        
        <!-- Report overall grades -->
        <div style="width: 100%;">
           <app-report-overall-grades 
                [TotalQualityText]="this.report()?.TotalQualityText ?? ''" 
                [TotalQuality]="this.report()?.TotalQuality ?? 0" 
                [GamePerformanceText]="this.report()?.GamePerformanceText ?? ''" 
                [GamePerformance]="this.report()?.GamePerformance ?? 0" 
                [CapacityText]="this.report()?.PlayerCapacityText ?? ''"  
                [Capacity]="this.report()?.PlayerCapacity ?? 0"
                [PlayerTypeText]="this.report()?.PlayerTypeText ?? ''"
                [PlayerType]="this.report()?.PlayerType ?? 0">
            </app-report-overall-grades>
        </div>
        
        <!-- META INFO below-->
        <div style="display: flex; flex-direction: column; flex-wrap: wrap; margin-top: 10px;">
             @if (this.report()?.GameText) {
                <div style="display: flex; flex-direction: row;">
                  <!--   <mat-icon style="font-size: 18px; height: 18px;">sports_hockey</mat-icon> -->
                    <div class="metavalue">
                              <a mat-icon-button    [routerLink]="[ '/scouting/gamedetails', this.report()?.GameId ]"  class="linktext">
                                 <mat-icon style="font-size: 18px; height: 18px;">sports_hockey</mat-icon>
                                 <!--{{ "GENERAL.GAME" | translate | uppercase }}-->
                               
                        {{this.report()?.GameText}}</a> <br/>
                        <div style="margin-left: 24px;">
                        {{this.report()?.ReportDivision}} - {{this.report()?.GameDate | date:'yyyy-MM-dd'}} 
                        </div>
                    </div>
                     
                    <div></div>
                </div>
            }
            @if (this.report()?.Location) {
                <div style="display: flex; flex-direction: row;">
                    <div>
                        <mat-icon style="font-size: 18px; height: 18px; "> location_on</mat-icon>
                    </div>
                    <div  class="metavalue">
                    {{ this.report()?.Location }}
                    
                    </div>
                </div>
            }
             @if (this.report()?.ScoutingSourceId!=0) {
             <div style="display: flex; flex-direction: row;">             
                <div  class="source">
                   {{ this.report()?.ScoutingSourceText }}
                </div>
            </div>
            }
          
            <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">
                <div>
                    <mat-icon style="font-size: 18px; height: 18px;">person</mat-icon>
                </div>
                <div class="metavalue">
                    {{this.report()?.CreatedByLastName}}, {{this.report()?.CreatedByFirstName}}  
                    <span style="font-size: 10px;">- {{this.report()?.DateCreated | date:'yyyy-MM-dd HH:mm' }}</span>
                </div>
            </div>
        </div>
       

</div>

